import script from "./ProposePolicyView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposePolicyView.vue?vue&type=script&setup=true&lang=js"

import "./ProposePolicyView.vue?vue&type=style&index=0&id=036aa018&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-036aa018"]])

export default __exports__